import { createLazyFeature } from './lazy-feature-loader.js';

const loadSegmenter = createLazyFeature(() => import('@formatjs/intl-segmenter/polyfill.js'), { automaticRecovery: false });

export async function ensureSegmenter(): Promise<void> {
  if (!Intl.Segmenter) {
    await loadSegmenter();
  }
}
